module.exports = __webpack_public_path__ + "img/henson-for-iowa-logo-text.61397670.svg";